<template>
  <div class="py-4">
    <div class="col-12 pr-0 flex overall">
      <div class="col-1 rating-grade">
        <span class="rating-avg">
          {{ rating }}
        </span>
        <span class="text-uppercase rating-sub">
          out of 5
        </span>
      </div>
      <div class="col-1 pr-2 text-right stars-container">
        <div class="stars">
          <i class="fa fa-star" /><i class="fa fa-star" /><i class="fa fa-star" /><i
            class="fa fa-star"
          /><i class="fa fa-star" />
        </div>
        <div class="stars">
          <i class="fa fa-star" /><i class="fa fa-star" /><i class="fa fa-star" /><i
            class="fa fa-star"
          />
        </div>
        <div class="stars">
          <i class="fa fa-star" /><i class="fa fa-star" /><i class="fa fa-star" />
        </div>
        <div class="stars"><i class="fa fa-star" /><i class="fa fa-star" /></div>
        <div class="stars"><i class="fa fa-star" /></div>
      </div>
      <template>
        <div class="col-5 review-stars-info stars-container">
          <div v-for="(value, index) in ratingPercentages" :key="index" class="progress mb-1" style="height: 8px">
            <div class="progress-bar" role="progressbar" :style="{ width: value.value + '%' }" aria-valuemin="0" aria-valuemax="100" />
          </div>
          <div class="d-flex justify-content-end align-content-start">
            <p class="ratings-text text-uppercase">Based on {{ ratingNumber }} Reviews</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    ratingNumber: {
      type: Number,
      default: () => [],
    },
    ratingPercentages: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.stars-container {
  padding-top: 26px;
}
.overall {
  .fa {
    font-size: 8px;
    color: #bdcad1;
  }

  .stars {
    justify-content: flex-end;
    position: relative;
    top: -2px;
    display: flex;
    margin-bottom: 4px;
  }
}
.rating-grade {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rating-avg {
  color: #4c5669;
  font-size: 55px;
  max-height: 73px;
}
.rating-sub {
  font-size: 10px;
}
.rating-heading {
  font-size: 13px;
  color: #8f8f8f;
}
.star-ratings {
  padding: 14px 24px 10px 14px;
  justify-content: space-evenly;
}
.ratings-text {
  font-size: 11px;
  color: #bbbbbb;
  font-weight: 600;
}
.customer-review {
  & p {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #6d7a86;
    margin-bottom: 12px;
    display: inline;
  }

  & a {
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ratings/Rating.vue